import React from "react";
import createRoot from "react-dom/client";
import "./assets/stylesheets/utilities.css";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

// Create a root.
const root = createRoot.createRoot(document.getElementById("root"));

// Initial render
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
